import './App.css';
import GeneratePassword from './components/generatePassword';

function App() {
  return (
    <div className="App">
        <GeneratePassword/>
    </div>
  );
}

export default App;
